<div class="modal-content">
    <div class="modal-header">
        <h5 class="modal-title">Choisir le type de compte à créer</h5>
        <button type="button" class="btn-close" (click)="modalServices.dismissAll()">
        </button>
    </div>
    <div class="modal-body">
        <div class="container" style="padding: 20px;">
            <form class="theme-form" *ngIf="registerForm2" [formGroup]="registerForm2" (ngSubmit)="handleSubmitRegister2($event)">
                <!-- <input type="hidden" formControlName="rang"> -->
                <div class="row">
                    <div class="col-lg-6">
                        <div class="form-group">
                            <label for="exampleInputPassword1">Domaine</label>
                            <select formControlName="domain_id" class="form-select" aria-label="Default select example" style="height: 50px;">
                                <option value="0" selected>Selectionnez votre domaine</option>
                                <option *ngFor="let option of domains" [value]="option.id">
                                    {{ option.name }}
                                </option>
                            </select>
                        </div>
                        <div class="form-error" *ngIf="isRegisterSubmited2 && registerFormControls2!['domain_id'].errors">
                            <div class="form-error-item" *ngIf="isRegisterSubmited2 && registerFormControls2!['domain_id'].errors['required']">
                                Veuillez remplir le champ domaine
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div class="form-group">
                            <label for="prenom">Nom de Scene</label>
                            <input type="text" formControlName="scene_name" class="form-control" id="scene_name"
                                placeholder="Votre nom de Scene" name="scene_name">
                            <app-feather-icon [icons]="'user'"
                                [class]="'input-icon iw-20 ih-20'"></app-feather-icon>
                        </div>
                        <div class="form-error" *ngIf="isRegisterSubmited2 && registerFormControls2!['scene_name'].errors">
                            <div class="form-error-item" *ngIf="isRegisterSubmited2 && registerFormControls2!['scene_name'].errors['required']">
                                Le nom de Scene est requis
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-6">
                        <div class="form-group">
                            <label for="prenom">Prénom</label>
                            <input type="text" formControlName="prenom" class="form-control" id="prenom"
                                placeholder="Votre Prénom" name="prenom">
                            <app-feather-icon [icons]="'user'"
                                [class]="'input-icon iw-20 ih-20'"></app-feather-icon>
                        </div>
                        <div class="form-error" *ngIf="isRegisterSubmited2 && registerFormControls2!['prenom'].errors">
                            <div class="form-error-item" *ngIf="isRegisterSubmited2 && registerFormControls2!['prenom'].errors['required']">
                                Veuillez remplir le champ prenom
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-6">
                        <div class="form-group">
                            <label for="name">Nom</label>
                            <input type="text" formControlName="name" class="form-control" id="name"
                                placeholder="Votre nom de famille" name="name">
                            <app-feather-icon [icons]="'user'"
                                [class]="'input-icon iw-20 ih-20'"></app-feather-icon>
                        </div>
                        <div class="form-error" *ngIf="isRegisterSubmited2 && registerFormControls2!['name'].errors">
                            <div class="form-error-item" *ngIf="isRegisterSubmited2 && registerFormControls2!['name'].errors['required']">
                                Veuilez remplir le champ Nom
                            </div>
                        </div>
                    </div>
                </div>  
                <div class="row">
                    <div class="col-lg-6">
                        <div class="form-group">
                            <label for="telephone">Téléphone</label>
                            <input type="text" formControlName="telephone" class="form-control" id="telephone"
                                placeholder="Votre numero de téléphone" name="telephone">
                            <app-feather-icon [icons]="'user'"
                                [class]="'input-icon iw-20 ih-20'"></app-feather-icon>
                        </div>
                        <div class="form-error" *ngIf="isRegisterSubmited2 && registerFormControls2!['telephone'].errors">
                            <div class="form-error-item" *ngIf="isRegisterSubmited2 && registerFormControls2!['telephone'].errors['required']">
                                Veuillez remplir le champ Téléphone
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-6">
                        <div class="form-group">
                            <label for="exampleInputEmail1">Adresse mail</label>
                            <input type="email" formControlName="email" class="form-control" id="exampleInputEmail1"
                                placeholder="Enter email" name="email">
                            <app-feather-icon [icons]="'user'"
                                [class]="'input-icon iw-20 ih-20'"></app-feather-icon>
                        </div>
                        <div class="form-error" *ngIf="isRegisterSubmited2 && registerFormControls2!['email'].errors">
                            <div class="form-error-item" *ngIf="isRegisterSubmited2 && registerFormControls2!['email'].errors['required']">
                                Veuillez remplir le champ mail
                            </div>
                            <div class="form-error-item" *ngIf="isRegisterSubmited2 && registerFormControls2!['email'].errors['email']">
                                L'adresse mail est invalide
                            </div>
                        </div>
                    </div>
                </div>  
                
                <div class="row">
                    <div class="col-lg-6">
                        <div class="form-group">
                            <label for="exampleInputPassword1">Password</label>
                            <input type="password"  class="form-control" formControlName="password" id="exampleInputPassword1"
                                placeholder="Password" name="password">
                        </div>
                        <div class="form-error" *ngIf="isRegisterSubmited2 && registerFormControls2!['password'].errors">
                            <div class="form-error-item" *ngIf="isRegisterSubmited2 && registerFormControls2!['password'].errors['required']">
                                password is required
                            </div>
                            <div class="form-error-item" *ngIf="isRegisterSubmited2 && registerFormControls2!['password'].errors['minLength']">
                                short passowrd
                            </div>
                        </div>
                    </div>
                    
                    <div class="col-lg-6">
                        <div class="form-group">
                            <label for="password_confirmation">Confirm Password</label>
                            <input type="password"  class="form-control" formControlName="password_confirmation" id="password_confirmation"
                                placeholder="password confirmation" name="password_confirmation">
                        </div>
                        <div class="form-error" *ngIf="isRegisterSubmited2 && registerFormControls2!['password_confirmation'].errors">
                            <div class="form-error-item" *ngIf="isRegisterSubmited2 && registerFormControls2!['password_confirmation'].errors['required']">
                                password_confirmation is required
                            </div>
                            <div class="form-error-item" *ngIf="isRegisterSubmited2 && registerFormControls2!['password_confirmation'].errors['minLength']">
                                password_confirmation passowrd
                            </div>
                        </div>
                    </div>
                </div>  
                <div class="btn-section mt-3">
                    <button class="btn btn-solid btn-lg" [disabled]="isLoading">
                        <span *ngIf="isLoading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                        <span *ngIf="!isLoading">Créer compte</span>
                    </button>
                </div>  
            </form>
        </div>
        <!-- <div [ngbNavOutlet]="nav" class="mt-2"></div> -->
    </div>
</div>
<div class="modal-footer">
    <button class="btn btn-solid" (click)="modalServices.dismissAll()">Fermer</button>
</div>